import React from 'react'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import Group from 'components/utils/Group'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

const MainContainer = styled(Group)`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: ${rem(24)};

  ${mediaQueryUp.tablet} {
    column-gap: ${rem(24)};
    row-gap: ${rem(32)};
  }
`

const HotelContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr ${rem(68)};
  gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: ${rem(164)} 1fr;
    gap: ${rem(24)};
  }
`

const HotelImageWrapper = styled.div`
  grid-column-start: 2;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaQueryUp.tablet} {
    grid-column-start: 1;
  }
`

const HotelContentWrapper = styled(Group)`
  grid-column-start: 1;
  grid-row: 1;
  
  ${mediaQueryUp.tablet} {
    grid-column-start: 2;
  }
`

function CarHireDiscountUpcomingOrderCarouselLoadingSkeleton() {
  return <LayoutContainer>
    <MainContainer direction="vertical" gap={20} desktopGap={32}>
      <HotelContainer>
        <HotelImageWrapper>
          <CSSBreakpoint min="desktop">
            <LoadingBox style={{ width: 164, height: 88 }} />
          </CSSBreakpoint>
          <CSSBreakpoint max="tablet">
            <LoadingBox style={{ width: 68, height: 68 }} />
          </CSSBreakpoint>
        </HotelImageWrapper>
        <HotelContentWrapper direction="vertical" gap={4} desktopGap={8}>
          <LoadingBox style={{ width: 100, height: 24 }} />
          <LoadingBox style={{ width: 200, height: 28 }} />
          <LoadingBox style={{ width: 100, height: 20 }} />
        </HotelContentWrapper>
      </HotelContainer>
    </MainContainer>
  </LayoutContainer>
}

export default CarHireDiscountUpcomingOrderCarouselLoadingSkeleton
